(() => {
  if (window.__vvHomeMotionInit) return;
  window.__vvHomeMotionInit = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const configs = [
    {
      scope: '.vv-hero',
      selectors: [
        ['.vv-hero__heading-line', 'vv-motion-heading'],
        ['.vv-hero__subheading'],
        ['.vv-hero__actions']
      ],
      baseDelay: 120,
      step: 120,
      immediate: true
    },
    {
      scope: '.vv-brand',
      selectors: [
        ['.vv-brand__eyebrow'],
        ['.vv-brand__heading', 'vv-motion-heading'],
        ['.vv-brand__body'],
        ['.vv-brand__image-wrap', 'vv-motion-image']
      ],
      step: 110
    },
    {
      scope: '.vv-craft',
      selectors: [
        ['.vv-craft__heading', 'vv-motion-heading'],
        ['.vv-craft__body'],
        ['.vv-craft__cta'],
        ['.vv-craft__media', 'vv-motion-image'],
        ['.vv-craft__step', 'vv-motion-card']
      ],
      step: 90
    },
    {
      scope: '.vv-features',
      selectors: [
        ['.vv-features__eyebrow'],
        ['.vv-features__heading', 'vv-motion-heading'],
        ['.vv-features__body'],
        ['.vv-features__card', 'vv-motion-card']
      ],
      step: 85
    },
    {
      scope: '.vv-moments',
      selectors: [
        ['.vv-moments__heading', 'vv-motion-heading'],
        ['.vv-moments__tile', 'vv-motion-image'],
        ['.vv-moments__label', 'vv-motion-label']
      ],
      step: 80
    },
    {
      scope: '.vv-manifesto',
      selectors: [
        ['.vv-manifesto__eyebrow'],
        ['.vv-manifesto__heading', 'vv-motion-heading'],
        ['.vv-manifesto__tagline'],
        ['.vv-manifesto__mission'],
        ['.vv-manifesto__body'],
        ['.vv-manifesto__cta']
      ],
      step: 95
    },
    {
      scope: '.vv-preview',
      selectors: [
        ['.vv-preview__eyebrow'],
        ['.vv-preview__heading', 'vv-motion-heading'],
        ['.vv-preview__body'],
        ['.vv-preview__reserve'],
        ['.vv-preview__waitlist-heading'],
        ['.vv-preview__field', 'vv-motion-label'],
        ['.vv-preview__consent', 'vv-motion-label'],
        ['.vv-preview__submit'],
        ['.vv-preview__note', 'vv-motion-label']
      ],
      step: 80
    }
  ];

  const scopes = [];

  const addMotion = (element, order, options) => {
    if (!(element instanceof HTMLElement)) return;
    element.classList.add('vv-motion-fade');
    if (options.extraClass) {
      element.classList.add(options.extraClass);
    }
    element.style.setProperty('--vv-reveal-delay', `${options.baseDelay + order * options.step}ms`);
  };

  configs.forEach((config) => {
    const root = document.querySelector(config.scope);
    if (!(root instanceof HTMLElement)) return;

    root.classList.add('vv-motion-scope');

    let order = 0;
    config.selectors.forEach(([selector, extraClass]) => {
      root.querySelectorAll(selector).forEach((element) => {
        addMotion(element, order, {
          baseDelay: config.baseDelay || 0,
          step: config.step || 80,
          extraClass
        });
        order += 1;
      });
    });

    scopes.push({ root, immediate: Boolean(config.immediate) });
  });

  if (!scopes.length) return;

  document.body.classList.add('vv-home-motion-ready');

  const reveal = (root) => {
    root.classList.add('is-visible');
  };

  scopes.forEach(({ root, immediate }) => {
    if (immediate) {
      window.requestAnimationFrame(() => reveal(root));
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.18,
      rootMargin: '0px 0px -12% 0px'
    }
  );

  scopes.forEach(({ root, immediate }) => {
    if (!immediate) {
      observer.observe(root);
    }
  });
})();